import { WhatsNew } from '@hai/ui-react';
import React, { useMemo, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { constant } from '../constant';
import systemInfo from '../data/systemInfo';

interface IWhatsNewModalProps {
  onCancel: VoidFunction;
}

export const WhatsNewModal = ({ onCancel }: IWhatsNewModalProps) => {
  const { t } = useTranslation();
  const version = systemInfo.version;
  // console.log('WhatsNewModal version', version);

  const jsonFile = useMemo(() => {
    return `whatsNew/locales/en/whatsNewContent.json`;
  }, []);

  const product = constant.productName;
  const productImage = 'MX4E';

  const [jsonFileExists, setJsonFileExists] = useState(false);

  useEffect(() => {
    const checkJsonFile = async () => {
      try {
        const response = await fetch(jsonFile);
        if (response.ok) {
          setJsonFileExists(true);
        } else {
          setJsonFileExists(false);
        }
      } catch (error) {
        setJsonFileExists(false);
      }
    };
    checkJsonFile();
  }, [jsonFile]);

  const handleDismiss = () => {
    const trVersion = version.substring(0, version.indexOf('-'));
    localStorage.setItem(constant.lStorage.whatsNewHiddenVersion, trVersion); // dismiss means dont show until next version
    onCancel();
  };

  // console.log('jsonFile', jsonFile);
  return (
    jsonFileExists && (
      <WhatsNew //Show the modal if jsonFileExists
        accentColor={constant.productColor}
        imagePath={'/whatsNew/images/'}
        jsonFile={`${jsonFile}`}
        product={product}
        productImage={productImage}
        localeInfo={{
          textBack: t('whatsnew.back'),
          textDismiss: t('whatsnew.dismiss'),
          textDone: t('whatsnew.done'),
          textNext: t('whatsnew.next'),
          textHeader: t('whatsnew.header'),
          textListHeader: t('whatsnew.listHeader'),
          textLearnMore: t('whatsnew.learnMore'),
          textStepFn: (current: any, total: any) => t('whatsnew.step', { current, total }),
        }}
        show
        handleCancel={onCancel}
        handleClose={handleDismiss}
      />
    )
  );
};
